module.exports = function getResource(label, vars = []) {
    let resources = {
        modalTitle: 'Store Details',
        backToList: 'Back to stores list'
    };

    return resources[label];
};
